import React from 'react';
import { StyledDropdownNode } from 'components/ConversationRating/ConversationRating.styles';
import isArray from 'lodash/isArray';
import { FEEDBACK_LABEL } from 'constants/ratingOptions';

const DropdownNodeDisabled = ({ nodeTitle, selectedExpert, ratingScoreDetails, expertList }) => {
  const getLabelForDisabledOption = (selectedOption) => {
    let _firstExpertName = selectedExpert.label ? ` (${selectedExpert.label})` : getFirstExpertName();

    return selectedOption === FEEDBACK_LABEL ? selectedOption + _firstExpertName : selectedOption;
  };

  const getFirstExpertName = () => {
    if (expertList.length > 0) {
      return ` (${expertList[0].label})` || '';
    }

    return '';
  };

  const isSelectedOptions = isArray(ratingScoreDetails[nodeTitle]) && ratingScoreDetails[nodeTitle].length > 0;

  return (
    <StyledDropdownNode className="disabled">
      <h3>{nodeTitle}</h3>
      {isSelectedOptions && (
        <ul>
          {ratingScoreDetails[nodeTitle].map((selectedOption) => {
            return (
              <li key={selectedOption} className="line">
                <input id={selectedOption} type="checkbox" checked disabled />
                <label htmlFor={selectedOption}>{getLabelForDisabledOption(selectedOption, nodeTitle)}</label>
              </li>
            );
          })}
        </ul>
      )}
    </StyledDropdownNode>
  );
};

export default DropdownNodeDisabled;
